import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, ArrowLeft } from "lucide-react";
import { API } from "../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API}/auth/me`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => { if (u) navigate("/admin"); })
      .catch(() => {});
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--anthracite)] text-white px-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <span className="font-serif text-lg w-11 h-11 flex items-center justify-center border border-[var(--gold)] text-[var(--gold)]">GR</span>
          <div className="leading-none">
            <div className="font-serif text-xl">Gabriella Ritondo</div>
            <div className="text-[0.6rem] uppercase tracking-[0.25em] text-white/50 mt-1">Area Riservata</div>
          </div>
        </div>

        <h1 className="font-serif text-4xl mb-3">Accesso amministratore</h1>
        <p className="text-white/60 mb-10">Riservato al titolare della holding. Accedi con il tuo account Google.</p>

        <button data-testid="google-login-btn" onClick={login}
          className="btn-fill w-full inline-flex items-center justify-center gap-3 bg-[var(--gold)] text-[var(--anthracite)] px-8 py-4 text-xs font-semibold uppercase tracking-[0.15em]"
          style={{ "--accent": "#ffffff" }}>
          <LogIn size={18} strokeWidth={1.75} /> Accedi con Google
        </button>

        <Link to="/" className="mt-8 inline-flex items-center gap-2 text-sm text-white/50 hover:text-white link-underline" data-testid="back-to-site">
          <ArrowLeft size={15} strokeWidth={1.5} /> Torna al sito
        </Link>
      </div>
    </div>
  );
}
